<template>
  <component :is="tag ?? 'div'" :class="rootClasses">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  tag?: string
  flexType?: string | string[]
  direction?: string | string[]
  wrap?: string | string[]
  flex?: string | string[]
  justifyContent?: string | string[]
  justifyItems?: string | string[]
  alignContent?: string | string[]
  alignItems?: string | string[]
  placeContent?: string | string[]
  placeItems?: string | string[]
}>()

const rootClasses = computed(() => [
  props.flexType ?? 'flex',
  props.direction,
  props.wrap,
  props.flex,
  // props.grow,
  // props.shrink,
  props.justifyContent,
  props.justifyItems,
  props.alignContent,
  props.alignItems,
  props.placeContent,
  props.placeItems,
])
</script>
